import classNames from 'classnames';
import type { JSX } from 'react';

import type { DataAttributes } from '@/types';

import primaryStyles from '../../styles/partials/block.primary-color.module.scss';

interface Props extends DataAttributes {
    as?: keyof JSX.IntrinsicElements;
    className?: string;
    children?: React.ReactNode;
}

/**
 * This component will set the background color and text color according to `primary` color inherited from nearest `ColorThemeProvider` container.
 */
export function ColorThemedBlock({
    children,
    as: WrapperTag = 'div',
    className,
    ...attributes
}: Props) {
    return (
        <WrapperTag {...attributes} className={classNames(primaryStyles.block, className)}>
            {children}
        </WrapperTag>
    );
}
